<div
  class="
    d-flex
    flex-column flex-column-fluid
    bgi-position-y-bottom
    position-x-center
    bgi-no-repeat bgi-size-contain bgi-attachment-fixed
  "
  [style.background-image]="
    'url(./assets/media/illustrations/sketchy-1/14.png)'
  "
>
  <div class="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20">
    <a
      *ngIf="!whiteLabelService.isWhiteLabel"
      (click)="routeToDashboard()"
      class="mb-10 pt-lg-20 cursor-pointer"
    >
      <img
        alt="Logo"
        src="./assets/media/logos/adshero_blue.svg"
        class="h-50px mb-5"
      />
    </a>
    <div class="pt-lg-10">
      <router-outlet></router-outlet>

      <div class="text-center">
        <a
          (click)="routeToDashboard()"
          class="btn btn-lg btn-primary fw-bolder cursor-pointer"
        >
          {{"ERROR.HOMEPAGE" | translate}}
        </a>
      </div>
    </div>
  </div>
</div>
